<template>
  <header class="home-header">
    <router-link to="/"> 
      <img
        class="logo"
        src="./../assets/header/logo.png"
        alt="沐桦科技"
      />
    </router-link>
    <div class="right-header">
      <Menu></Menu>
      <div class="login"><router-link to="/login">登陆</router-link> | <router-link to="/signUp">注册</router-link></div>
    </div>
  </header>
</template>

<script>
import Menu from "@/components/Menu.vue";

export default {
  name: "Footer",
  props: {
    // msg: String,
  },
  components: {
    Menu
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.home-header .login:hover {
  background: #008BBF;
  cursor: pointer;
}

.home-header .login {
  box-sizing: border-box;
  margin: 15px 40px;
  padding: 0 10px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background: #00aeef;
  border-radius: 4px;

  a {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: #fff;
    line-height: 30px;
    color: #fff;
  }
}

.logo {
  width: 126px;
  height: 40px;
  margin: 10px 0;
}

.right-header {
  position: absolute;
  right: 0;
  top: 0;
  line-height: 60px;
  display: flex;
}

.home-header {
  height: 60px;
  background: #FFFFFF;
  margin: 0 auto;
  position: relative;
  padding-left: 17px;
  width: 100%;
}
</style>
